import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-2b9a2a82"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "topnav"
};
const _hoisted_2 = {
  class: "left"
};
const _hoisted_3 = {
  class: "title"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "active"
}, "发现", -1));

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "云村", -1));

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "视频", -1));

const _hoisted_7 = {
  class: "search"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");

  const _component_van_popup = _resolveComponent("van-popup");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_icon, {
    name: "wap-nav",
    color: "#262626",
    size: "25",
    onClick: _cache[0] || (_cache[0] = $event => $data.isPopups = true)
  })]), _createElementVNode("div", _hoisted_3, [_createElementVNode("span", {
    onClick: _cache[1] || (_cache[1] = $event => _ctx.$router.push('/center'))
  }, "我的"), _hoisted_4, _hoisted_5, _hoisted_6]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_van_icon, {
    name: "search",
    color: "#262626",
    size: "25",
    onClick: _cache[2] || (_cache[2] = $event => _ctx.$router.push('/search'))
  })]), _createVNode(_component_van_popup, {
    show: $data.isPopups,
    "onUpdate:show": _cache[3] || (_cache[3] = $event => $data.isPopups = $event),
    position: "left",
    style: {
      height: '100%',
      width: '40%'
    }
  }, null, 8, ["show"])]);
}